export default {
  caseFilters: [
    { label: 'Processes', value: 'processes' },
    { label: 'Status', value: 'status' },
    { label: 'Creation date', value: 'creation_date' },
    { label: 'Current Process Enter Date', value: 'current_process_date' },
    { label: 'Client IDs', value: 'client_ids' },
    { label: 'Debtors IDs', value: 'debtors_ids' },
    { label: 'Case Groups', value: 'case_groups' },
    { label: 'All Custom Fields', value: 'custom_fields' },
    { label: 'Filetypes', value: 'fileTypes' },
    { label: 'Statements', value: 'statements' },
  ],
  clientFilters: [
    { label: 'City', value: 'city' },
    { label: 'Countries', value: 'countries' },
    { label: 'Creation Date', value: 'creation_date' },
    { label: 'Bank Information', value: 'bank_info' },
    { label: 'Active Cases', value: 'active_cases' },
    { label: 'Total Cases', value: 'total_cases' },
    { label: 'All Custom Fields', value: 'custom_fields' },
    { label: 'Termsheetcode', value: 'termsheetcode' },
  ],
  debtorFilters: [
    { label: 'City', value: 'city' },
    { label: 'Countries', value: 'countries' },
    { label: 'Creation Date', value: 'creation_date' },
    { label: 'Active Cases', value: 'active_cases' },
    { label: 'Total Cases', value: 'total_cases' },
    { label: 'All Custom Fields', value: 'custom_fields' },
  ],
  caseColumns: [
    { label: 'Case ID', value: 'id' },
    { label: 'Base Document Type', value: 'base_document_type' },
    { label: 'Custom Fields', value: 'custom_fields' },
    { label: 'Client ID', value: 'client_id' },
    { label: 'Client Name', value: 'client_name' },
    { label: 'Client Phone Number', value: 'client_phone_number' },
    { label: 'Client Email', value: 'client_email' },
    { label: 'Client Type', value: 'client_type' },
    { label: 'Client City', value: 'client_city' },
    { label: 'Client Country', value: 'client_country' },
    { label: 'Debtor ID', value: 'debtor_id' },
    { label: 'Debtor Name', value: 'debtor_name' },
    { label: 'Debtor Email', value: 'debtor_email' },
    { label: 'Debtor Phone Number', value: 'debtor_phone_number' },
    { label: 'Debtor Type', value: 'debtor_type' },
    { label: 'Debtor City', value: 'debtor_city' },
    { label: 'Debtor Country', value: 'debtor_country' },
    { label: 'Case Group', value: 'case_group' },
    { label: 'Active Process', value: 'active_process' },
    { label: 'Status', value: 'status' },
  ],
  clientColumns: [
    { label: 'Client ID', value: 'id' },
    { label: 'Client Name', value: 'client_name' },
    { label: 'Username', value: 'client_username' },
    { label: 'Email', value: 'client_email' },
    { label: 'Phone Number', value: 'client_phone_number' },
    { label: 'Login Permission', value: 'client_login_permission' },
    { label: 'Billing Email', value: 'client_billing_email' },
    { label: 'Contact Person', value: 'client_contact_person' },
    { label: 'Client Type', value: 'client_type' },
    { label: 'Number of Cases', value: 'client_no_of_cases' },
    { label: 'VAT Exempted Client', value: 'client_vat_exemption' },
    { label: 'Bank Branch', value: 'client_bank_branch_no' },
    { label: 'Bank Account No', value: 'client_bank_account_no' },
    { label: 'IBAN', value: 'client_iban' },
    { label: 'Swift Code', value: 'client_swift_code' },
    { label: 'House Number', value: 'client_house_name' },
    { label: 'Road Name', value: 'client_road_name' },
    { label: 'Place Name', value: 'client_place_name' },
    { label: 'Zip Code', value: 'client_zip_code' },
    { label: 'City', value: 'client_city' },
    { label: 'Country', value: 'client_country' },
    { label: 'Billing House Number', value: 'client_billing_house_number' },
    { label: 'Billing Road Name', value: 'client_billing_road_name' },
    { label: 'Billing Place Name', value: 'client_billing_place_name' },
    { label: 'Billing Zip Code', value: 'client_billing_zip_code' },
    { label: 'Billing City', value: 'client_billing_city' },
    { label: 'Billing Country', value: 'client_billing_country' },
  ],
  debtorColumns: [
    { label: 'Debtor ID', value: 'id' },
    { label: 'Debtor Name', value: 'debtor_name' },
    { label: 'Username', value: 'debtor_username' },
    { label: 'Email', value: 'debtor_email' },
    { label: 'Phone Number', value: 'debtor_phone_number' },
    { label: 'Login Permission', value: 'debtor_login_permission' },
    { label: 'Contact Person', value: 'debtor_contact_person' },
    { label: 'Debtor Type', value: 'debtor_type' },
    { label: 'Number of Cases', value: 'debtor_no_of_cases' },
    { label: 'Birth Date', value: 'debtor_vat_exemption' },
    { label: 'Bank Branch', value: 'debtor_bank_branch_no' },
    { label: 'Bank Account No', value: 'debtor_bank_account_no' },
    { label: 'House Number', value: 'debtor_house_name' },
    { label: 'Road Name', value: 'debtor_road_name' },
    { label: 'Place Name', value: 'debtor_place_name' },
    { label: 'Zip Code', value: 'debtor_zip_code' },
    { label: 'City', value: 'debtor_city' },
    { label: 'Country', value: 'debtor_country' },
    { label: 'Client', value: 'debtor_client' },
    { label: 'Representative', value: 'debtor_representative' },
  ],
}
